<div class="screen-element quick-action">
	<app-statusbar class="screen-element"></app-statusbar>
	<div class="dashboard-center">
		<div class="icon {{dashIcon}}"></div>
	</div>
	<text-widget class="text text-1" [color]="'white'" [text]="getText(0)"></text-widget>
	<text-widget class="text text-2" [color]="'white'" [text]="getText(1)"></text-widget>
	<text-widget class="text text-3" [color]="'grey'" [text]="getText(2)"></text-widget>
	
</div>